import { FC } from "react";
import { useHistory } from "react-router-dom";
import { GetActivityTypes_activityTypes } from "api/MyLivestock/Activity/types/GetActivityTypes";
import { useGetActivityTypes, useGetAnimalTypes, useStateSpecies } from "hooks";
import { ImportCustomWizardAnimalType } from "../state/importCustomWizardMachine";
import { ActivityTemplateIcon } from "components/Activity";
import { Button, Flex, Icon, Spacer } from "components";
import { WizardOptions } from "import/components/WizardOptions";

interface ImportWizardChooseTypeProps {
  onSelectActivityType: (activityType: GetActivityTypes_activityTypes) => void;
  onSelectAnimalImport: (animalType: ImportCustomWizardAnimalType) => void;
}

export const ImportWizardChooseType: FC<ImportWizardChooseTypeProps> = ({
  onSelectActivityType,
  onSelectAnimalImport,
}) => {
  const { data: activityTypes } = useGetActivityTypes();
  const filteredActivityTypes = activityTypes.filter((activityType) => activityType.activityTemplatesCount);

  const { active: speciesActive } = useStateSpecies();

  const { data: animalTypesData } = useGetAnimalTypes();
  const animalTypeCattle = animalTypesData?.animalTypes?.find((item) => item?.slug === "cattle");

  const animalType = speciesActive || animalTypeCattle;
  const handleSelectAnimalImport = () => (animalType ? onSelectAnimalImport(animalType) : undefined);

  const history = useHistory();
  const handleClickBack = () => history.goBack();

  return (
    <>
      <WizardOptions>
        {filteredActivityTypes.map((activityType) => {
          const handleClick = () => onSelectActivityType(activityType);

          return (
            <WizardOptions.Option key={activityType.id} name={activityType.name} onClick={handleClick}>
              {activityType.image && (
                <ActivityTemplateIcon activityTemplateName={activityType.name} src={activityType.image} />
              )}
            </WizardOptions.Option>
          );
        })}

        {speciesActive && (
          <>
            <WizardOptions.Separator>or</WizardOptions.Separator>

            <WizardOptions.Option name={`Import ${speciesActive.name}`} onClick={handleSelectAnimalImport}>
              {speciesActive.image && (
                <Icon circled colourOverride={speciesActive.colour} size="large" src={speciesActive.image} />
              )}
            </WizardOptions.Option>
          </>
        )}
      </WizardOptions>

      <Spacer baselineHeight={4} />

      <Flex container containerJustifyContent="space-between">
        <Button caption="Back" colour="grey" onClick={handleClickBack} variant="hollow" />
      </Flex>
    </>
  );
};
